<template lang="pug">
.ui-form-group(:class="{ 'ui-form-group--error': errorMessage }")
  .ui-form-group__label(v-if="label || $slots.label")
    UiInputLabel
      slot(name="label") {{ label }}
  .ui-form-group__input
    slot
  .ui-form-group__feedback
    UiInputFeedback(
      v-if="errorMessage"
      error
    ) {{ errorMessage }}
    UiInputFeedback(
      v-else-if="success"
      success
    ) {{ success }}
    UiInputFeedback(v-else-if="description") {{ description }}
</template>

<script>
export default {
  props: {
    label: {
      type: [String, Number],
      default: null,
    },
    description: {
      type: [String, Number],
      default: null,
    },
    error: {
      type: [String, Number],
      default: null,
    },
    success: {
      type: [String, Number],
      default: null,
    },
    vuelidateModel: {
      type: Object,
      default: null,
    },
  },

  computed: {
    errorMessage() {
      if (this.error) {
        return this.error;
      }

      if (this.vuelidateModel?.$errors?.length) {
        return this.vuelidateModel.$errors[0].$message;
      }

      return null;
    },
  },
};
</script>

<style lang="scss">
.ui-form-group {
  & + & {
    margin-top: 1.2rem;
  }
}
</style>
